export const CALENDAR_REQUESTING = 'CALENDAR_REQUESTING'
export const CALENDAR_SUCCESS = 'CALENDAR_SUCCESS'
export const CALENDAR_ERROR = 'CALENDAR_ERROR'
